import type { AlertEmailMode } from '../../api/types.js';
import { color, font, fontSize, radius } from '../../theme/tokens.js';

/**
 * The banner (blueprint lines 1133–1142): how many recruiters break BoB rules in the CURRENT view.
 *
 * ⚠ The second line is a claim about email, so it is only made while it is true (FR-AL11): "notified
 * by email" appears only in live mode. In dry-run or test mode nobody on this list has been emailed,
 * and saying so would be the one sentence on the page a reader cannot check.
 */
export function AlertsBanner({ count, mode }: { count: number; mode: AlertEmailMode }) {
  return (
    <div
      style={{
        background: color.surface,
        border: `1px solid ${color.dangerBorder}`,
        borderLeft: `4px solid ${color.alert}`,
        borderRadius: radius['5xl'],
        padding: '16px 20px',
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        gap: 13,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width: 40,
          height: 40,
          borderRadius: radius['2xl'],
          background: color.dangerBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 'none',
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color.negative} strokeWidth="2">
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <path d="M12 9v4M12 17h.01" />
        </svg>
      </div>
      <div style={{ flex: 1 }}>
        <div role="status" style={{ fontSize: fontSize.bodyStrong, fontWeight: 700, color: color.ink }}>
          <span className="mono" style={{ fontFamily: font.mono }}>{count}</span> recruiter{count === 1 ? '' : 's'} breaking BoB rules
        </div>
        <div style={{ fontSize: fontSize.control, color: color.inkFaint }}>
          {mode === 'live'
            ? 'Defaulters are notified by email and flagged here until resolved.'
            : 'Flagged here until resolved.'}
        </div>
      </div>
    </div>
  );
}
